<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required: _required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();
</script>

<div
	class={[
		"flex text-left",
		horizontal ? "flex-row items-center gap-2 md:gap-3" : "flex-col gap-0.5 md:gap-3",
		wrapperClass,
	]}
>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label} class={["text-xs/[1.1] uppercase md:text-sm/[1.2]", label?.class]}>
		{@render rest.children?.()}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
